<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="./../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Orders</span>
              </b-col>
              <b-col cols="12" md="1" class="py-2 text-right">
                <span>Type :</span>
              </b-col>
              <b-col cols="12" md="3" class="py-2">
                <b-form-select
                  v-model="orderStatus"
                  id="orderStatus"
                  :options="orderStatuses"
                  text-field="name"
                  value-field="name"
                ></b-form-select>
              </b-col>
            </b-row>
          </template>
          <b-table
            :filter="filter"
            :filter-included-fields="filterOn"
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="orders"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(name)="data">
              <span v-if="data.item.name.length > 50">{{
                data.item.name.slice(0, 50) + "..."
              }}</span>
              <span v-else>{{ data.item.name }}</span>
            </template>
            <template v-slot:cell(order_items)="data">
              <span>{{ data.item.order_items.length }}</span>
            </template>
            <template v-slot:cell(status)="data">
              <b-badge
                pill
                variant="primary"
                v-if="data.item.status == 'Placed'"
                >{{ data.item.status }}</b-badge
              >
              <b-badge
                pill
                variant="danger"
                v-else-if="data.item.status == 'Cancelled'"
                >{{ data.item.status }}</b-badge
              >
              <b-badge
                pill
                variant="warning"
                v-else-if="data.item.status == 'Payment Not Confirmed'"
                >{{ data.item.status }}</b-badge
              >
              <b-badge
                pill
                variant="success"
                v-else-if="data.item.status == 'Deliver Complete'"
                >{{ data.item.status }}</b-badge
              >
              <b-badge pill variant="light" v-else>{{
                data.item.status
              }}</b-badge>
            </template>
            <template v-slot:cell(ordered_at)="data">
              <span>{{ formatDate(data.item.ordered_at) }}</span>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalData"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      orderStatus: "All",
      orderStatuses: [
        { name: "All", value: 0 },
        { name: "Payment Not Confirmed", value: 1 },
        { name: "Placed", value: 2 },
        { name: "Cancelled", value: 3 },
        { name: "Rejected", value: 4 },
        { name: "Confirmed", value: 5 },
        { name: "Delivery En Route", value: 6 },
        { name: "Deliver Complete", value: 7 },
      ],
      orders: [],
      fields: [
        { key: "customer.name", label: "Name", sortable: false },
        { key: "order_items", label: "Ordered Items", sortable: false },
        { key: "price", label: "Price", sortable: false },
        { key: "status", label: "Status", sortable: true },
        { key: "ordered_at", label: "Ordered At", sortable: true },
        { key: "_id", label: "Ordered ID", sortable: false },
      ],
      filter: null,
      filterOn: [],
      totalData: 0,
      currentPage: 1,
      perPage: 200,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      oldOrder: [],
    };
  },
  watch: {
    orderStatus() {
      if (this.orderStatus == "All") {
        this.filter = null;
      } else {
        this.filter = this.orderStatus;
      }
    },
  },
  beforeMount() {
    this.getData();
    // setTimeout(() => {
    //   this.getData2();
    // }, 10000);
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getCategory();
    },

    getData() {
      this.appLoading = true;
      axios({
        url: "/order/all",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.data) {
            this.orders = response.data.data;
            for (var i = 0; i < this.orders.length; i++) {
              for (var j = 0; j < this.orderStatuses.length; j++) {
                if (this.orders[i].status == this.orderStatuses[j].value) {
                  this.orders[i].status = this.orderStatuses[j].name;
                }
              }
            }
            this.orders.reverse();
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getData2() {
      axios({
        url: "/order/all",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // setTimeout(() => {
          //   this.getData2();
          // }, 10000);

          if (response.data.data.length > this.orders.length) {
            this.$notify({
              group: "appNotification",
              title: "New Order Received",
              text: "",
              type: "success",
              position: "bottom right",
            });
          }
          if (response.data.data) {
            this.orders = response.data.data;
            for (var i = 0; i < this.orders.length; i++) {
              for (var j = 0; j < this.orderStatuses.length; j++) {
                if (this.orders[i].status == this.orderStatuses[j].value) {
                  this.orders[i].status = this.orderStatuses[j].name;
                }
              }
            }
            this.orders.reverse();
          }
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    rowClicked(item) {
      this.$router.push("/Orders/" + item._id);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
